module.exports = __webpack_public_path__ + "img/ex (2).ec27e6f3.jpeg";